import React from "react";
import { NavLink } from "react-router-dom";
import Year from "../../components/timesheet/Year";
import Payperiod from "../../components/timesheet/Payperiod";
import { useSidebarData } from "../../hooks/sidebarData";
import { useQuery } from "@tanstack/react-query";

const Child = () => {
    const { setSidebarData } = useSidebarData();

    const uname = sessionStorage.getItem('uname') || ''; 
    const breadcrumbChild = sessionStorage.getItem('timesheetChild') || 'N/A';

    const handleClearSidebarData = () => {
        setSidebarData('state', false);
        setSidebarData('key', '');
        setSidebarData('label', '');
        setSidebarData('data', []);
    };

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments } = useQuery({
        queryKey: ['managedDepartments', uname]
    });

    const { data: managedadjustments } = useQuery({
        queryKey: ['managedAdjustments', uname]
    });

    return (
        <div className="child">
            <div className="page-header">
                <div className='title'>
                    <h1>Timesheets</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to='/dtr/my-dtr' onClick={handleClearSidebarData}>DTR</NavLink>
                        </li>
                        <li>
                            <NavLink to='/dtr/timesheets' onClick={handleClearSidebarData}>Timesheets</NavLink>
                        </li>
                        <li>
                            <span>{breadcrumbChild}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="content">
                <div className="files">
                    {(role === 'admin' || role === 'management')|| manageddepartments?.length > 1 || managedadjustments?.length > 1   
                        ? <Year /> 
                        : <Payperiod />
                    }
                </div>
            </div>
        </div>
    );
}

export default Child;